









































import {Vue, Component} from 'vue-property-decorator';
import {toI18n} from '@/utils/commonUtils';
import XLSX from 'xlsx';
import moment from 'moment';
import {writeExcel, getStorageByName} from '@/utils/excel';

@Component
export default class ModifySalePriceAndImmediateDiscount extends Vue {
  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t(needToI18nStr));
  }

  public msToI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_POP_PRODUCTLIST_' + needToI18nStr));
  }

  private onClickDownloadExcelForm() {
    // window.location.assign(`${process.env.VUE_APP_PREVIOUS_API_URL}/object-storage?fileName=${encodeURI('product_price_discount_sample.xlsx')}`);
    getStorageByName('product_price_discount_sample_20220425.xlsx');
  }

  private onClickExcelUploadFile() {
    $('#excelFile').val('').trigger('click');
  }

  private updateExcelUploadFile(e: any) {
    const file = e.target.files[0];
    if (!file.name.toLowerCase().match(/\.(xlsx)$/)) {
      // alert(this.toI18n('PRODUCT_PRIORITY_REGISTRATION_FAILED_MSG'));
      this.displayResultMessage(this.msToI18n('MSBATCH_CHANGE_RESULT'), this.msToI18n('MSUPLOAD_FAILED_BADLY_FORMATTED_FILE'));

      return;
    }
    const KEY_MAP_JSON = {
      [this.msToI18n('MSPRODUCT_NUMBER')]: 'productNo',
      [this.msToI18n('MSCHANGE_PRICE')]: 'salePrice',
      [this.msToI18n('MSIMMEDIATE_DISCOUNT')]: 'immediateDiscountValue',
      [this.msToI18n('MSINSTANT_DISCOUNT_UNIT')]: 'immediateDiscountUnitType',
      [this.msToI18n('MSSTART_DATE_AND_TIME_OF_IMMEDIATE_DISCOUNT')]: 'immediateDiscountStartDateTime',
      [this.msToI18n('MSIMMEDIATE_DISCOUNT_END_DATE')]: 'immediateDiscountEndDateTime'
    };
    this.callbackAfterToJson('excelFile', KEY_MAP_JSON, $.proxy(this.convertExcelData, this));
  }

  private groupBy(xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }

  private isPositiveInteger(str) {
    return /^\+?(0|[1-9]\d*)$/.test(str);
  }

  private isNumeric(n) {
    return !isNaN(n);
  }

  private rangeNumeric(n, min, max) {
    if (this.isNumeric(n) && this.isNumeric(min) && this.isNumeric(max)) {
      return n >= min && n <= max;
    }
    return false;
  }

  private writeExcel(data) {
    const keyMapJson = {
      productNo: this.msToI18n('MSPRODUCT_NUMBER'),
      salePrice: this.msToI18n('MSCHANGE_PRICE'),
      immediateDiscountValue: this.msToI18n('MSIMMEDIATE_DISCOUNT'),
      immediateDiscountUnitType: this.msToI18n('MSINSTANT_DISCOUNT_UNIT'),
      immediateDiscountStartDateTime: this.msToI18n('MSSTART_DATE_AND_TIME_OF_IMMEDIATE_DISCOUNT'),
      immediateDiscountEndDateTime: this.msToI18n('MSIMMEDIATE_DISCOUNT_END_DATE'),
      result: this.msToI18n('MSRESULT')
    };

    writeExcel(data, keyMapJson, 'result_product_price_discount', {});
  }

  private convertExcelData(excelData: any) {
    // console.log('%c 🥐 excelData: ', 'font-size:20px;background-color: #E41A6A;color:#fff;', excelData);
    if (excelData.length > 500) {
      this.displayResultMessage(this.msToI18n('MSBATCH_CHANGE_RESULT'), this.msToI18n('MSUPLOAD_FAILED_THE_MAXIMUM_NUMBER_OF'));
      return;
    }

    // 첫번째 row 의 productNo 기준으로 유효한지 판단한다.
    let firstRow = excelData.find((row, i) => i === 0);
    if (firstRow && isNaN(parseInt(firstRow.productNo, 10)) && !firstRow.salePrice && !firstRow.immediateDiscountValue) {
      this.displayResultMessage(this.msToI18n('MSBATCH_CHANGE_RESULT'), this.msToI18n('MSUPLOAD_FAILED_BADLY_FORMATTED_FILE'));
      return;
    }

    let dupMallProductNo = [];
    let excelDataGroup = this.groupBy(excelData, 'productNo');
    for (let prop in excelDataGroup) {
      if (Object.prototype.hasOwnProperty.call(excelDataGroup, prop)) {
        if (excelDataGroup[prop].length > 1) {
          dupMallProductNo.push(prop);
        }
      }
    }

    const data = excelData
      .filter((row, i) => i >= 0)
      .map((row) => {
        let startYmdt = row.immediateDiscountStartDateTime;
        let endYmdt = row.immediateDiscountEndDateTime;

        if ((row.productNo && !this.isPositiveInteger(row.productNo)) || row.productNo > 2147483647) {
          // 상품번호 정수가 아닐 경우
          row['result'] = this.msToI18n('MSFAILURE');
          // console.log(`상품번호 ${row.productNo}의 실패사유: 'productNo 가 유효하지 않음'`);
          return row;
        }

        // 판매가가 정수가 아닐 경우
        if (row.salePrice && !this.isPositiveInteger(row.salePrice)) {
          row['result'] = this.msToI18n('MSFAILURE');
          // console.log(`상품번호 ${row.productNo}의 실패사유: '판매가(${row.salePrice}) 가 유효하지 않음'`);
          return row;
        }

        if (dupMallProductNo.includes(row.productNo)) {
          row['result'] = this.msToI18n('MSFAILURE');
          // console.log(`상품번호 ${row.productNo}의 실패사유: 중복된 상품 번호`);
          return row;
        }

        // 즉시할인가 숫자 확인
        if (row.immediateDiscountValue && !this.isPositiveInteger(row.immediateDiscountValue)) {
          row['result'] = this.msToI18n('MSFAILURE');
          // console.log(`상품번호 ${row.productNo}의 실패사유: '즉시할인가(${row.immediateDiscountValue}) 가 유효하지 않음'`);
          return row;
        }
        // 즉시할인 타입 확인
        if (row.immediateDiscountUnitType && !this.rangeNumeric(row.immediateDiscountUnitType, 1, 2)) {
          row['result'] = this.msToI18n('MSFAILURE');
          // console.log(`상품번호 ${row.productNo}의 실패사유: '즉시할인 타입(${row.immediateDiscountUnitType}) 이 유효하지 않음'`);
          return row;
        }
        // 시작일 종료일 중에 하나만 있는 경우
        if ((!startYmdt && endYmdt) || (startYmdt && !endYmdt)) {
          row['result'] = this.msToI18n('MSFAILURE');
          // console.log(`상품번호 ${row.productNo}의 실패사유: '즉시할인기간('${startYmdt}', '${endYmdt}') 값이 없음.'`);
          return row;
        }
        if (startYmdt && endYmdt) {
          if (!moment(startYmdt, 'YYYYMMDDHH', true).isValid() || !moment(endYmdt, 'YYYYMMDDHH', true).isValid()) {
            row['result'] = this.msToI18n('MSFAILURE');
            // console.log(`상품번호 ${row.productNo}의 실패사유: '즉시할인기간('${startYmdt}', '${endYmdt}') 날짜 포맷이 올바르지 않음.'`);
            return row;
          }
        }
        return row;
      })
      .filter((row) => {
        // 사전 데이터 검증에서 실패인 경우
        if (row.result === this.msToI18n('MSFAILURE')) {
          return false;
        }
        return true;
      })
      .map((row) => {
        let startYmdt = row.immediateDiscountStartDateTime;
        let endYmdt = row.immediateDiscountEndDateTime;

        if (startYmdt + ''.length && endYmdt + ''.length) {
          startYmdt = moment(startYmdt, 'YYYYMMDDHH').set({minute: 0, second: 0, millisecond: 0}).format('YYYY-MM-DD HH:mm:ss');
          endYmdt = moment(endYmdt, 'YYYYMMDDHH').set({minute: 59, second: 59, millisecond: 0}).format('YYYY-MM-DD HH:mm:ss');
        }

        let immediateDiscountUnitType = null;
        if (row.immediateDiscountUnitType + '' === '1') {
          immediateDiscountUnitType = 'AMOUNT';
        } else if (row.immediateDiscountUnitType + '' === '2') {
          immediateDiscountUnitType = 'PERCENT';
        }

        const rowData = {
          productNo: row.productNo,
          salePrice: row.salePrice ? parseInt(row.salePrice.toString().replace(/[^0-9]/g, ''), 10) : null,
          immediateDiscountValue: row.immediateDiscountValue ? parseInt(row.immediateDiscountValue.toString().replace(/[^0-9]/g, ''), 10) : null,
          immediateDiscountUnitType: immediateDiscountUnitType,
          immediateDiscountStartDateTime: startYmdt,
          immediateDiscountEndDateTime: endYmdt
        };

        return rowData;
      })
      .filter((row) => {
        // 처리할 데이터가 있는지 확인한다.
        if (!row.productNo && !row.salePrice && !row.immediateDiscountValue && !row.immediateDiscountStartDateTime && !row.immediateDiscountEndDateTime) {
          return false;
        }

        // 사전 데이터 검증에서 실패인 경우
        if (row.result === this.msToI18n('MSFAILURE')) {
          return false;
        }
        return true;
      });

    // 일괄 업로드 서버 요청 전 데이터 확인
    // console.log('%c 🍋 data: ', 'font-size:20px;background-color: #465975;color:#fff;', data);
    if (data.length === 0) {
      let failureCount = excelData.filter((row) => row.result === this.msToI18n('MSFAILURE')).length;
      if (failureCount > 0) {
        // 서버 전송하기 전 검증에서 이미 유효한 데이터가 없는 경우MD_KEY MSFAILURE MSSUCCESS
        this.displayResultMessage(
          this.msToI18n('MSBATCH_CHANGE_RESULT'),
          `${this.msToI18n('MSSUCCESS')}: 0${this.msToI18n('MD_KEY')}, ${this.msToI18n('MSFAILURE')}: ${failureCount}${this.msToI18n('MD_KEY')}`,
          false
        );
        this.writeExcel(excelData);
      } else {
        this.displayResultMessage(this.msToI18n('MSBATCH_CHANGE_RESULT'), this.msToI18n('MSUPLOAD_FAILED_NO_INPUT_VALUE'));
      }
      return;
    }

    this.$api.putProductsPrice({data}).then(({data: {failures, successNos}}: any) => {
      this.resultExcel(failures, successNos, excelData);
    });
  }

  private resultExcel(failures, successNos, originData) {
    let resultArr = [];
    successNos.forEach((o) => {
      resultArr.push({productNo: o, result: this.msToI18n('MSSUCCESS')});
    });

    if (failures.length) {
      resultArr = resultArr.concat(
        failures.map((item: any): any => {
          return {productNo: item.mallProductNo, result: this.msToI18n('MSFAILURE')};
        })
      );
    }

    let resultArrGroup = this.groupBy(resultArr, 'productNo');
    for (let i = 0; i < originData.length; i++) {
      let rd = originData[i];
      let productNo = rd.productNo;
      if (resultArrGroup[productNo] != null) {
        Object.assign(originData[i], {result: resultArrGroup[productNo][0].result});
      } else {
        originData[i]['result'] = this.msToI18n('MSFAILURE');
      }
    }

    const successCount = successNos.length;
    const originDataFailureCount = originData.filter((row) => row.result === this.msToI18n('MSFAILURE')).length;
    this.displayResultMessage(
      this.msToI18n('MSBATCH_CHANGE_RESULT'),
      `${this.msToI18n('MSSUCCESS')}:${successCount}${this.msToI18n('MD_KEY')}, ${this.msToI18n('MSFAILURE')}:${originDataFailureCount}${this.msToI18n('MD_KEY')}`,
      false
    );

    this.writeExcel(originData);
  }

  public callbackAfterToJson(fileId: any, keyMapJson: any, callback: any): void {
    function _arrayBufferToStr(data: ArrayBuffer): any {
      let o = '',
        l = 0,
        w = 10240;
      for (; l < data.byteLength / w; ++l) o += String.fromCharCode.apply(null, new Uint16Array(data.slice(l * w, l * w + w)) as any);
      o += String.fromCharCode.apply(null, new Uint16Array(data.slice(l * w)) as any);

      return o;
    }

    function _processWorkbook(workbook: any, keyMapJson: any, callback: any): any {
      let firstSheetName = workbook.SheetNames[0];
      let rowObjectArray = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheetName]);
      let json = JSON.stringify(rowObjectArray);
      json = json.replace(/"\s+|\s+"/gi, '"');
      $.each(keyMapJson, function (key, value): any {
        json = json.replace(new RegExp('"' + (key as string) + '"', 'g'), '"' + value + '"');
      });

      callback(JSON.parse(json));
    }

    if (typeof FileReader === 'undefined') {
      let ExcelError = function (): void {
        this.name = 'FileReader Not Found Exception';
        this.message = this.toI18n('PRODUCT_PRIORITY_MESSAGE1');
      };
      ExcelError.prototype = new Error();
      return new ExcelError();
    }

    let fileObj = typeof fileId === 'object' ? fileId : $(`#${fileId}`);
    if (fileObj == null || fileObj.length == 0) {
      // eslint-disable-next-line quotes
      throw new Error(this.toI18n('PRODUCT_PRIORITY_ERROR1'));
    }

    if (fileObj[0].files.length == 0) {
      throw new Error(this.toI18n('PRODUCT_PRIORITY_ERROR2'));
    }

    let file = fileObj[0].files[0];

    let isUsableReadAsBinaryString = typeof FileReader.prototype.readAsBinaryString !== 'undefined';
    // let isUsableWorker = typeof Worker !== 'undefined';

    let reader = new FileReader();

    reader.onload = function (e: any): void {
      let data = e.target.result;
      let workbook;
      if (isUsableReadAsBinaryString) {
        workbook = XLSX.read(data, {type: 'binary'});
      } else {
        let str = _arrayBufferToStr(data);
        workbook = XLSX.read(btoa(str), {type: 'base64'});
      }
      _processWorkbook(workbook, keyMapJson, callback);
    };

    if (isUsableReadAsBinaryString) {
      reader.readAsBinaryString(file);
    } else {
      reader.readAsArrayBuffer(file);
    }
  }

  private displayResultMessage(title, result, fontRed = true) {
    $('#uploadTitle').text(title);
    $('#uploadResult').html(`${fontRed ? '<span class="text-red">' : ''}${result}${fontRed ? '</span>' : ''} `);
  }

  private close() {
    window.close();
  }

  private created() {
    document.body.classList.add('popup');
    window.name = 'MSPAID';
  }
}
